import type { Theme } from '@mui/material';

export const styles = {
  errorMsg: (theme: Theme) => ({
    color: theme.palette.error.main,
  }),
};
